import { AvatarWithLabel } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { StyledListItem } from '../styled';
export function Source(props) {
    const { text, isActive, on, off } = props;
    return (<StyledListItem onClick={(ev) => {
            ev.stopPropagation();
            if (isActive) {
                off();
            }
            else {
                on();
            }
        }}>
      <AvatarWithLabel appearance={isActive ? 'assistant' : 'primary'} size="sm" title={text}>
        <Falcon icon="highlighter"/>
      </AvatarWithLabel>
    </StyledListItem>);
}
